export default [         
    { value: 'article', text: 'Articles', variant: 'primary' },  
    { value: 'audio', text: 'Audios', variant: 'info' },  
    { value: 'book', text: 'Books', variant: 'warning' },  
    { value: 'collection', text: 'Collections', variant: 'success' },  
    { value: 'course', text: 'Courses', variant: 'light' },  
    { value: 'guide', text: 'Guides', variant: 'light' },  
    { value: 'podcast', text: 'Podcasts', variant: 'dark' },  
    { value: 'tool', text: 'Tools', variant: 'secondary' },  
    { value: 'video', text: 'Videos', variant: 'danger' },  
    { value: 'other', text: 'Other', variant: 'secondary' },  
  ]